const fallbackMediaSrc = "https://cloudinary-marketing-res.cloudinary.com/images/w_1000,c_scale/v1699909962/fallback_image_header/fallback_image_header-png?_i=AA";

export { fallbackMediaSrc };
//# sourceMappingURL=const.fallback-image.js.map
